const state = {
  location: {
    latitude: null,
    longitude: null,
  },
  error: {
    code: null,
    message: '',
  },
  id: null,
}

export const getters = {
  location: state => {
    if (state.error.code) {
      return null
    }
    return { latitude: state.location.latitude, longitude: state.location.longitude }
  },
}

export const mutations = {
  setLocation(state, { latitude, longitude }) {
    state.location.latitude = latitude
    state.location.longitude = longitude
  },

  setError(state, error) {
    if (error) {
      state.error.code = error.code
      state.error.message = error.message
    }
  },

  setId(state, watchID) {
    state.watchID = watchID
  },
}

export const actions = {
  watch({ state, commit }) {
    if (state.id) {
      helpers.error({
        code: null,
        message: 'Watch position is already running, unable to start it again',
      })
    }
    if (navigator && 'geolocation' in navigator) {
      commit('setId', navigator.geolocation.watchPosition(helpers.success, helpers.error))
    } else {
      helpers.error({ code: null, message: 'Geolocation API is not present in this browser' })
    }
  },

  clear({ state, commit }) {
    if (state.id) {
      navigator.geolocation.clearWatch(state.id)
      commit('setId', null)
    }
  },

  getCurrentLocation() {
    if (!navigator || !navigator.geolocation) {
      helpers.error()
      return null
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    }
    return navigator.geolocation.getCurrentPosition(helpers.success, helpers.error, options)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}

// For internal use
export const helpers = {
  success({ coords: { latitude, longitude } }) {
    Vue.$store.commit('geolocation/setLocation', { latitude, longitude })
    Vue.$store.commit('geolocation/setError', { code: null, message: '' })
  },

  error(error) {
    Vue.$store.commit('geolocation/setError', error)
  },
}

export const api = {}
